import React from 'react';
import { Table, Card, Button, message, Icon, Tooltip, Col, Row } from 'antd';
import InfiniteScroll from 'react-infinite-scroller';
import { withRouter } from 'kts-platform-frame/routes';
import { invoiceInput } from 'src/api';
import { Field } from 'kts-scaffold-framework/utils/doc';
import moment from 'moment';
import { invoiceType } from 'kts-platform-frame/display/part/InvoiceImport/InvoiceTab/VerifyInvoice';
import LogListForm from './LogListForm';
import Urls from 'kts-platform-frame/entry/constant/Urls';
import { InvoiceImport } from 'kts-platform-frame/display/part';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { JSObject } from 'kts-scaffold-framework/utils/kit';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { typeDescNew } from 'kts-platform-frame/entry/constant/InvoiceType/EnumInvoiceType';
const css = require('./index.scss');

interface IProps extends IPropsBasic {
    fresh?: string;
}
@withRouter
class LogList extends UIBasic<IProps, ModulesState> {

    private columns = [
        {
            dataIndex: 'index',
            width: 100,
            className: 'text-center',
            render: (text, record) => {
                return (
                    <div >
                        {/* {
                            record.invoiceCode &&
                            <div className="ui-item-icon input-type bg-green">{invoiceType(record.invoiceCode)}
                            </div>
                        } */} 
                        { 
                            <div className="ui-item-icon input-type bg-green" style={{width:'auto',padding:'0 5px'}}>
                                {typeDescNew(record)}
                            </div>

                        }
                    </div>
                );
            }
        },
        {
            title: '',
            dataIndex: 'decodeState',
            width: 33,
            className: 'text-center',
            render: (text, record) => {
                return (
                    <span>
                        {text === 'FAILED' &&
                            <Tooltip title={record.decodeMsg}>
                                <Icon type="warning" style={{ color: '#EB6100' }} />
                            </Tooltip>
                        }
                        {
                            record.decodeState === 'RECOGNITION' &&
                            <Tooltip title={record.decodeMsg}>
                                <Icon type="hourglass" />
                            </Tooltip>
                        }
                    </span>
                );
            }
        },
        {
            title: '发票代码',
            width: 125,
            dataIndex: 'invoiceCode'
        },
        {
            title: '发票号码',
            width: 110,
            dataIndex: 'invoiceNumber'
        },
        {
            title: '开票日期',
            width: 110,
            dataIndex: 'invoiceDate',
            render: (text) => Field.formatDate(text)
        },
        {
            title: '无税金额',
            width: 93,
            dataIndex: 'amountWithoutTax',
            render: (text) => text && Field.formatMoney(text, 2)
        },
        {
            title: '校验码',
            width: 90,
            dataIndex: 'invoiceParityCode',
            render: (text, record) => {
                return (
                    <span> {record.invoiceCode && invoiceType(record.invoiceCode) !== '专' && invoiceType(record.invoiceCode) !== '机' && text}</span>
                );
            }
        },
        {
            title: '录入时间',
            dataIndex: 'loggedDate',
            width: 160,
            render: (text, record) => {
                return (
                    <div>
                        {text && moment(text).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                );
            }
        },
        {
            title: '录入人',
            width:100,
            dataIndex: 'userName',
        },
        {
            title: '录入方式',
            width: 90,
            dataIndex: 'loggingType',
            render: (text) => {
                return (<span>
                    {text === 'MANUAL' && '手动'}
                    {text === 'SCANNER_GUN' && '扫描枪'}
                    {text === 'IMAGE' && '影像文件'}
                    {text === 'SCANISTOR' && '扫描仪'}
                    {text === 'EXCEL' && 'excel上传'}
                    {text === 'MAILBOX' && '邮箱'}
                </span>);
            }
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            className: 'text-right',
            width: 140,
            render: (text, record) => {
                return (
                    <div>
                        {
                            !!record.decodeState &&
                            <span className="pd5 hand" onClick={() => this.viewFailedImage(record)}>影像</span>
                        }
                    </div>
                );
            }
        }
    ];
    private intervalId: number;
    constructor(props: any) {
        super(props, ModulesAction);
        this.state = {
            list: [],
            pageMeta: {},
            expand: false,
            pageNum: 1,
            pageSize: 20,
            fields: this.modulesState.logFields,
            message: null,
            show: false,
            hasMore: true,
            loading: false,
            refresh: false,
            fresh: this.props.fresh
        };

    }
    viewFailedImage = record => {
        this.props.history.push(`/workbench/invoiceInput/addshadow/${record.invoiceEntryLogId}`);

    }
    clearFields = () => {
        this.setState({
            fields: {}
        });
        this.modulesState.logFields = {};
        ModulesAction.setModulesState();
    }
    handleFormChange = (changedFields) => {
        this.setState({
            fields: { ...this.state.fields, ...changedFields },
        });
    }
    /**
     * 刷新界面需要先把数据重置，然后再发送数据请求接口
     */
    refreshInvoice = () => {
        this.setState({
            list: [],
            pageNum: 1,
            pageSize: 20,
            hasMore: true,
            loading: false,
        }, () => { this.getData(); });
    }
    componentDidMount() {
        this.getData();
        //this.intervalId=window.setInterval(()=>{this.refreshInvoice();},5000);
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.fresh !== this.state.fresh) {
            this.setState({
                fresh: nextProps.fresh
            }, () => { this.refreshInvoice(); });
        }
    }
    componentWillUnmount() {
        window.clearInterval(this.intervalId);
    }
    toggle = () => {
        // const { expand } = this.state;
        // this.setState({ expand: !expand });
        let { fields } = this.state;
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <LogListForm
                clearFields={this.clearFields}
                fields={fields}
                onValuesChange={this.handleFormChange}
                getData={this.refreshInvoice}
            />,
            title: '筛选'
        });
    }
    handleInfiniteOnLoad = async () => {
        this.setState({
            loading: true,
        });
        const { pageMeta } = this.state;

        if (pageMeta.pageSize * pageMeta.pageNum < pageMeta.total) {
            this.setState({
                pageNum: this.state.pageNum + 1
            }, () => { this.getData(); });
        }
    }
    onShowInvoicePanel = () => {
        const urlData = {
            key3: Urls.logInvoiceMANUAL,
            scankey4: Urls.logInvoiceSCANNER_GUN,
            qrtoken: Urls.group_getUploadToken,
            downloadurl: Urls.group_downloadTemplate,
            url: Urls.group_uploadFile,
            scanerurl: Urls.group_ocrtoken,
            show: true
        };
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <InvoiceImport urlData={urlData} refreshInvoice={this.onRefresh} />,
            title: '发票录入'
        });
    }
    onRefresh = () => {
        this.refreshInvoice();
    }
    render() {

        let columns = this.columns;
        let { selectedRowKeys, fields, list } = this.state;
        // if (list.length === 0) {
        //     return false;
        // }
        let dataSource = list.map((item, index) => {
            return { ...item, index };
        });
        const { match, location } = this.props;
        return (
            <div style={{ display: match.url === location.pathname ? '' : 'none' }} >
                <Row className={`${css['invoice-card-hander']}`}>
                    <Col span={12} className="text-left">
                        <Button
                            className={`mr10 font10 ${css['invoice-input-button']} ${css['invoice-card-button']}`}
                            onClick={this.onShowInvoicePanel}
                        >
                            发票录入
                        </Button>
                    </Col>
                    <Col span={12} className="text-right">
                        <Button
                            onClick={this.toggle}
                            className={`mr10 mb-10 font10 ${css['invoice-card-button']}`}
                            htmlType="submit"
                            icon="shaixuan font13"
                        >
                            筛选
                        </Button>
                        <Button
                            // icon="sync font13"
                            // icon="shuaxin font13"
                            icon="sync"
                            className={`mr10 font10 ${css['invoice-card-button']}`}
                            onClick={this.onRefresh}
                        >
                        </Button>
                    </Col>
                </Row>
                {/* <div style={{ display: this.state.expand ? 'block' : 'none' }}>
                    <LogListForm
                        clearFields={this.clearFields}
                        fields={fields}
                        onValuesChange={this.handleFormChange}
                        getData={this.refreshInvoice}
                    />
                </div> */}
                <div style={{ height: (this.state.expand ? 'calc(100Vh - 280px)' : 'calc(100Vh - 112px)'), overflow: 'auto' }}>
                    <InfiniteScroll
                        initialLoad={false}
                        pageStart={0}
                        loadMore={this.handleInfiniteOnLoad}
                        hasMore={!this.state.loading && this.state.hasMore}
                        useWindow={false}
                    >
                        <Table
                            className="ui-list"
                            style={{ borderColor: '#E9EAEB' }}
                            bordered={true}
                            dataSource={dataSource}
                            indentSize={0}
                            columns={columns}
                            rowClassName={(record, index) => {
                                return (
                                    'ui-item doc-item'
                                );
                            }}
                            rowKey="index"
                            defaultExpandAllRows={true}
                            pagination={false}
                            scroll={{ x: 1000 }}
                        />
                    </InfiniteScroll>
                </div>
            </div >
        );
    }
    getData = async () => {
        let { fields, pageNum, pageSize } = this.state;
        fields = { ...fields, pageNum, pageSize };
        this.modulesState.logFields = { ...fields };
        ModulesAction.setModulesState();
        fields = {
            ...fields,
            minLoggedDate:
                fields['minLoggedDate'] &&
                fields['minLoggedDate'].format('YYYY-MM-DD HH:mm:ss'),
            maxLoggedDate:
                fields['maxLoggedDate'] &&
                fields['maxLoggedDate'].format('YYYY-MM-DD HH:mm:ss'),
            minInvoiceDate:
                fields['minInvoiceDate'] &&
                fields['minInvoiceDate'].format('YYYY-MM-DD HH:mm:ss'),
            maxInvoiceDate:
                fields['maxInvoiceDate'] &&
                fields['maxInvoiceDate'].format('YYYY-MM-DD HH:mm:ss'),
        };
        fields = JSObject.getClearBlankParas(fields);
        fields = JSObject.clearBlankArray(fields);
        invoiceInput.invoiceLogList(this, fields).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    let list = this.state.list;
                    list = list.concat(res.items);
                    if (res.pageMeta.pageNum * res.pageMeta.pageSize > res.pageMeta.total) {
                        console.log('没有更多了');
                        this.setState({
                            hasMore: false
                        });
                    }
                    this.setState({
                        list: list,
                        pageMeta: res.pageMeta,
                        loading: false,
                        refresh: false
                    });
                }
            }
        });
    }
}
export default LogList;



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/LogList.tsx